import db from '@/plugins/dexie';
import { geraDataNuvem, formatarDataParaConsultaNuvem } from './geradata';

export default async function obterUltimaDataTabela(tabela, campoatt) {
  if (!db[tabela] || !campoatt) return '1997-01-01 13:00:00.000';
  try {
    const itens = await db[tabela].toArray();
    if (!itens || itens.length === 0) return '1997-01-01 13:00:00.000';

    let maxTs = -Infinity;
    let maxDataIso = null;
    const paraCorrigir = [];

    itens.forEach((item) => {
      const valorData = item[campoatt];
      if (valorData) {
        if (typeof valorData === 'string' && valorData.startsWith('1997-01-01')) {
          return;
        }

        let dataIso;
        if (typeof valorData === 'string' && (valorData.endsWith('Z') || valorData.includes('+'))) {
          dataIso = valorData;
        } else {
          // Normaliza valores legados sem timezone (ou Date) para ISO UTC
          dataIso = geraDataNuvem(valorData);
          if (dataIso && dataIso !== valorData) {
            paraCorrigir.push({ key: item.id, changes: { [campoatt]: dataIso } });
          }
        }

        const ts = new Date(dataIso).getTime();
        if (!Number.isNaN(ts) && ts > maxTs) {
          maxTs = ts;
          maxDataIso = dataIso;
        }
      }
    });

    if (paraCorrigir.length > 0) {
      try {
        await db[tabela].bulkUpdate(paraCorrigir);
      } catch (e) {
        // Ignora caso falhe atualização em lote
      }
    }

    if (maxDataIso) {
      return formatarDataParaConsultaNuvem(maxDataIso);
    }
  } catch (err) {
    console.warn(`Erro ao obter última data da tabela ${tabela}:`, err);
  }
  return '1997-01-01 13:00:00.000';
}
